module.exports = __webpack_public_path__ + "static/_colorbase_BL001-f66b4da8667c7bf38560592372c59e8e.png";